import React from 'react'
import { Routes, Route, Navigate } from "react-router-dom";
import ForgotPasswordPage from '../pages/public/ForgotPasswordPage';

const ForgotPasswordRoutes = () => {
  return (
    <Routes>
      <Route path="/request" element={<ForgotPasswordPage request_type="request" />} />
      <Route path="/email" element={<ForgotPasswordPage request_type="email" />} />
      <Route path="/reset" element={<ForgotPasswordPage request_type="reset" />} />
      <Route path="/resetdone" element={<ForgotPasswordPage request_type="resetdone" />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  )
}

export default ForgotPasswordRoutes;
